/**
 * Platform HTTP contracts shared by the web shell and Worker boundary.
 * These schemas expose operational identity only; configuration and secrets are never fields.
 */
import { z } from "zod";

export const healthResponseSchema = z
  .object({
    status: z.literal("ok"),
    environment: z.string().min(1),
    version: z.string().min(1),
    requestId: z.string().min(1)
  })
  .strip();

export type HealthResponse = z.infer<typeof healthResponseSchema>;

export const apiErrorEnvelopeSchema = z.object({
  error: z.object({
    code: z.string().min(1),
    message: z.string().min(1),
    requestId: z.string().min(1),
    details: z.record(z.string(), z.unknown())
  })
});

export type ApiErrorEnvelope = z.infer<typeof apiErrorEnvelopeSchema>;
